// extracted by mini-css-extract-plugin
export default {"box":"index_box_nemeU","oneLine":"index_oneLine_DQwK-","twoLine":"index_twoLine_QYM8X"};